export default __webpack_public_path__ + "img/cwEdRqak.a831c07a.svg";